import React, {useEffect, useRef} from "react";
import gsap from "gsap";

//Images

import TitleBG from "../images/background-04.jpg";
import TitleBGRet from "../images/background-04@2x.jpg";
import TitleBGWebp from "../images/background-04.webp";
import TitleBGWebpRet from "../images/background-04@2x.webp";

import src01 from "../images/image4_1-01.jpg";
import src01Ret from "../images/image4_1-01@2x.jpg";
import webp01 from "../images/image4_1-01.webp";
import webp01Ret from "../images/image4_1-01@2x.webp";

import src02 from "../images/image4_1-02.jpg";
import src02Ret from "../images/image4_1-02@2x.jpg";
import webp02 from "../images/image4_1-02.webp";
import webp02Ret from "../images/image4_1-02@2x.webp";

import src03 from "../images/image4_2-01.jpg";
import src03Ret from "../images/image4_2-01@2x.jpg";
import webp03 from "../images/image4_2-01.webp";
import webp03Ret from "../images/image4_2-01@2x.webp";

import src04 from "../images/image4_2-02.jpg";
import src04Ret from "../images/image4_2-02@2x.jpg";
import webp04 from "../images/image4_2-02.webp";
import webp04Ret from "../images/image4_2-02@2x.webp";

import src05 from "../images/image4_2-03.jpg";
import src05Ret from "../images/image4_2-03@2x.jpg";
import webp05 from "../images/image4_2-03.webp";
import webp05Ret from "../images/image4_2-03@2x.webp";

import src06 from "../images/image4_3-01.jpg";
import src06Ret from "../images/image4_3-01@2x.jpg";
import webp06 from "../images/image4_3-01.webp";
import webp06Ret from "../images/image4_3-01@2x.webp";


import styles from "./Section04.module.scss";

import Content from "./Elements/Content";
import Title from "./Elements/Title"
import Block from "./Elements/Block";
import ImageText from "./Elements/ImageText";

import Highlight from "./Elements/Highlight";
import Image from "./Global/Image";
import MailAttack from "./Graph/MailAttack";
import CompanyAttack from "./Graph/CompanyAttack";


export default function Section04() {
    const sectionTitle = `Les risques « cyber » et les perdants du télétravail`;

    return (
        <Content classname={'navigation--1'}>
            <Title title={sectionTitle} numero={4}
                   background={{src: TitleBG, srcRet: TitleBGRet, webp: TitleBGWebp, webpRet: TitleBGWebpRet}}/>

            <Block title={'Les cyberattaques, l’autre pandémie mondiale'} number={4.1} sectionTitle={sectionTitle}
                   classname={'navigation--2'}>

                <div className="container">
                    <ImageText image={{src: src01, srcRet: src01Ret, webp: webp01, webpRet: webp01Ret}} radius={true}
                               classname={'rtl with--margin'}>
                        <p>
                            S’il implique des bouleversements profonds, le télétravail peut par ailleurs constituer une
                            menace sérieuse pour la sécurité informatique des entreprises. En raison notamment du
                            développement des usages numériques et de la généralisation du télétravail qui a poussé les
                            sociétés à s’adapter à un modèle de communication à distance (mail, chat, vidéoconférence…),
                            l'année 2020 a été marquée par une explosion des cyberattaques qui a touché les entreprises.
                            L’an dernier, plusieurs grandes entreprises ont également défrayé la chronique à la suite
                            d’une attaque de ransomware (ou rançongiciel), un logiciel malveillant capable de chiffrer
                            l’ensemble des données d’un appareil ou d’un système tout entier, les rendant totalement
                            inaccessibles. Tous les secteurs ont été impactés, depuis les fabricants et les fournisseurs
                            de services d’utilité publique tels que KIA Motors et Colonial Pipeline, aux firmes
                            technologiques comme CD Projekt Red et Acer, en passant par les entreprises de services
                            financiers telles que CNA et AXA. les structures de soin, les grandes entreprises, les
                            collectivités territoriales. L’épidémie de ransomwares ne se limite pas aux entreprises et à
                            leurs clients. En effet, elle affecte également le secteur des soins de santé et les
                            patients. Hôpitaux, cliniques et réseaux fédérés tels que le National Health Service (NHS)
                            au Royaume-Uni ont également été touchés. L'Agence nationale de la sécurité des systèmes
                            d'information (Anssi) rapporte une augmentation de 255% des signalements d'attaques par
                            ransomware en 2020. Un chiffre qui reste en deçà de la réalité puisque toutes les attaques
                            informatiques ne font pas l'objet d'un signalement.
                        </p>
                    </ImageText>
                </div>

                <Highlight color={'green'} font={'black'}
                           title={`Attaques notables et volumes d’emails malveillants <br/> durant la pandémie en 2020`}
                           source={'Rapport "Le facteur humain 2021", Proofpoint'} classname={'full'}>
                    <MailAttack/>
                </Highlight>

                <div className="container">
                    <ImageText image={{src: src02, srcRet: src02Ret, webp: webp02, webpRet: webp02Ret}} radius={true}>
                        <p>
                            Une enquête réalisée par Opinion pour CESIN, dévoilée en janvier 2022, a également révélé
                            que 54% des entreprises françaises avaient subi au moins une attaque en 2021, un chiffre
                            légèrement en baisse par rapport aux vagues précédentes (57% en 2020 et 65% en 2019), ce qui
                            montre que les dispositifs mis en place progressivement portent leur fruit, la crise
                            sanitaire et le développement du télétravail ayant conduit les entreprises à revoir les
                            dispositifs de sécurité mis en place.
                        </p>

                        <p>
                            Selon l’édition 2022 du "Global Risks Report" du Forum économique mondial, les dangers liés
                            à la cybersécurité ont été amplifiés par la pandémie, avec le recours massif au télétravail
                            et la dépendance croissante des pays au numérique. « En 2020, les attaques de logiciels
                            malveillants et de rançongiciels ont augmenté respectivement de 358% et de 435% », rapporte
                            l’organisation. Au début de l’année 2021, le monde de la cybersécurité a été notamment
                            marqué par la gigantesque attaque sur la plateforme Orion de l'éditeur américain SolarWinds,
                            dévoilée en décembre. L'attaque, dont l'étendue des dégâts reste encore difficile à définir,
                            aura mis en danger les données de 180.000 entreprises, dont Microsoft et Cisco, et agences
                            fédérales américaines par l'insertion d'une « porte dérobée » baptisée Sunburst, à
                            l'intérieur d'une mise à jour du logiciel de SolarWinds.
                        </p>
                    </ImageText>
                </div>
            </Block>

            <Block title={'Les entreprises au cœur des défis de la cybersécurité'} number={4.2}
                   sectionTitle={sectionTitle}
                   classname={'navigation--2'}>

                <div className="container" style={{zIndex: 2}}>
                    <ImageText image={{src: src03, srcRet: src03Ret, webp: webp03, webpRet: webp03Ret}} radius={true}
                               classname={'rtl with--margin pl-1'}>
                        <p>
                            Déjà désorganisées par la pandémie, certaines victimes ont parfois eu du mal à s'en
                            remettre. Selon la société de gestion sécurisée des identités et des accès Okta, les
                            attaques de ransomware augmentent de 30% d’année en année, ce qui représenterait un coût
                            total de 20 milliards de dollars rien qu’en 2021 si les projections se maintiennent. Encore
                            une fois, ces estimations ne sont que la pointe de l’iceberg, car toutes les attaques de
                            ransomware ne sont pas signalées et tous les paiements de rançon ne sont pas divulgués.
                        </p>
                    </ImageText>
                </div>

                <Highlight color={'purple'}
                           title={`Les cyberattaques les plus courantes <br/> contre les entreprises françaises en 2021`}
                           source={'Enquête d’OpinionWay pour le CESIN, janvier 2022'} classname={['full', styles.Cyber].join(' ')}>

                    <p>
                        <small>
                            <strong>
                                La question
                            </strong>
                        </small>
                        Parmi les vecteurs d’attaques suivants, lesquels ont impacté votre entreprise au cours des 12 derniers mois ?
                    </p>

                    <CompanyAttack/>
                </Highlight>

                <div className="container">
                    <ImageText image={{src: src04, srcRet: src04Ret, webp: webp04, webpRet: webp04Ret}} radius={true}>
                        <p>
                            Mais l’explosion des attaques cyber en temps de pandémie de Covid-19 a été notamment l'occasion d'une prise de conscience par les entreprises de l'importance de la sécurité informatique. Le télétravail a ainsi remis la cybersécurité sur le devant de la scène, incitant les entreprises à solliciter des services et conseils en informatique (Capgemini, Atos ou encore Neurones…). Le marché de la sécurité informatique ne s’est d’ailleurs jamais aussi bien porté depuis la crise sanitaire. « Le passage à un modèle d’exploitation en télétravail a des implications importantes pour la sécurité informatique et la cybersécurité, avec des risques croissants », affirme Capgemini dans une note de recherche publiée en avril 2020, citant l’exemple de Cisco Systems, où « le nombre de demandes d’assistance de la part des télétravailleurs pour des problèmes de sécurité » avait décuplé durant les premières semaines après le début de la pandémie de Covid-19. Selon l’étude internationale Global Digital Trust Insights Survey 2021, réalisée par PwC en octobre dernier, 55 % des entreprises prévoient d’augmenter leurs budgets en cybersécurité et de recruter dans ce domaine en 2021.
                        </p>
                    </ImageText>

                    <ImageText image={{src: src05, srcRet: src05Ret, webp: webp05, webpRet: webp05Ret}} radius={true} classname={'rtl pl-1 small'}>
                        <p>
                            Fin 2020, un consortium composé de 19 entreprises spécialisées en cybersécurité, dont McAfee et Microsoft, ainsi que divers organismes avaient d’ores et déjà pris les devants, en lançant la "Ransomware Task Force" pour créer un cadre commun de lutte contre la menace croissance des attaques par rançongiciels. Le site web du groupement a été lancé en janvier 2021. Cette coalition créée à l'initiative de l'Institute for Security and Technology (IST) se concentre sur l'évaluation des solutions techniques existantes qui offrent des protections en cas d'attaque par un logiciel de rançon. En France, pour la première fois, le gouvernement a présenté une stratégie nationale après plusieurs années d'inertie, avec un plan à un milliards d’euros pour renforcer la cybersécurité. Dans le cadre du plan France Relance, l'Agence nationale de la sécurité des systèmes d'information (ANSSI) a bénéficié d'une enveloppe de 136 millions d'euros pour réaliser notamment des diagnostics de sécurité auprès des établissements de santé et des collectivités territoriales, en s’appuyant sur des acteurs locaux de confiance.
                        </p>
                    </ImageText>
                </div>
            </Block>

            <Block title={'Les perdants'} number={4.2}
                   sectionTitle={sectionTitle}
                   classname={'navigation--2'}>
                <div className="container">
                    <p className={'size-6 ml-4'}>
                        Si le télétravail a permis à certains acteurs d’en ressortir gagnants, d’autres ne connaissent pas le même sort. Dans les marchés matures, les changements de comportements concernant le travail à distance ont en effet eu des répercussions dans la restauration d’entreprise notamment, les magasins, les commerces et entreprises de services aux alentours des bureaux, ainsi que dans les transports publics. Lors des confinements mis en place en France pour tenter d’enrayer la pandémie de Covid-19, la restauration collective avait d’ores et déjà beaucoup souffert, comme en témoignaient les comptes de deux leaders français du secteur, Elior et Sodexo. La crise sanitaire avait coûté 1 milliard de chiffre d’affaires à Elior durant l’exercice clos fin septembre 2020, et le résultat net avait basculé dans le rouge à hauteur de 483 millions d’euros. De son côté, Sodexo avait subi une chute de plus de 27% de ses facturations au second semestre 2020 et les comptes annuels s’étaient soldés par une perte nette de 315 millions.
                    </p>

                    <Image src={src06} srcRet={src06Ret} webp={webp06} webpRet={webp06Ret} radius={true} classname={[styles.Image, 'size-7'].join(' ')}/>


                    <p className={'size-6 ml-4'}>
                        L'immobilier de bureau va également connaître des mutations en profondeur. En effet, le télétravail va obliger les entreprises, notamment sur la réorganisation des espaces de bureaux. Selon une étude de l’Institut de l’épargne immobilière et foncière, la place prise par le travail à distance devrait inciter les entreprises, qui peuvent en profiter pour réaliser des économies de mètres de carrés, à réduire leurs surfaces immobilières de bureaux, de 2% à 12% selon les scénarios projetés…
                    </p>
                </div>

            </Block>
        </Content>
    )
}
